import { ApplicationConfig } from '@angular/core';

import { routes } from './app.routes';
import {provideCore} from "./core/core";
import {provideMarkdown} from "ngx-markdown";

export const appConfig: ApplicationConfig = {
  providers: [
    provideCore({ routes }),
    provideMarkdown(),
  ],
};
